import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{attrs:{"color":_vm.color,"text":_vm.isText,"plain":_vm.plain},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v("\n"+_vm._s(_vm.text)+"\n ")])
}
var staticRenderFns = []

export { render, staticRenderFns }